import { IDocument } from 'common/document/interfaces/document';
import { DocumentStatusEnum } from '../../../../../common/document/enums/document-status.enum';

interface ICanDownloadDriverLicense {
  document?: IDocument;
  photoIdDocument?: IDocument;
}

export interface ICanDownloadDriverLicenseResult {
  status: 'success' | 'fail' | 'disabled';
  helpText: string;
}

export const canDownloadDriverLicense = ({
  document,
  photoIdDocument,
}: ICanDownloadDriverLicense): ICanDownloadDriverLicenseResult => {
  if (document?.containsUserPhoto) {
    if (document?.status === DocumentStatusEnum.APPROVED) {
      return {
        status: 'success',
        helpText: '',
      };
    } else {
      return {
        status: 'fail',
        helpText: '',
      };
    }
  } else {
    if (document?.status === DocumentStatusEnum.APPROVED) {
      if (photoIdDocument?.status === DocumentStatusEnum.APPROVED) {
        return {
          status: 'success',
          helpText: '',
        };
      } else {
        return {
          status: 'disabled',
          helpText:
            '<div><b>Not Verified:</b></div><div>Photo ID document must be approved.</div>',
        };
      }
    } else {
      return {
        status: 'fail',
        helpText: '',
      };
    }
  }
};
